/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/practiceMode/practiceModeHooks.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import enviro from 'enviro';
import { useState } from 'react';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { SHORT_IDS_PRACTICE_MODE_PROD, SHORT_IDS_PRACTICE_MODE_QA } from './practiceModeConsts.migrated';
const isEnabledForShort = shortId => {
  if (!shortId) return false;
  if (enviro.isQa()) {
    return SHORT_IDS_PRACTICE_MODE_QA.includes(shortId);
  }
  return SHORT_IDS_PRACTICE_MODE_PROD.includes(shortId);
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/practiceMode/practiceModeHooks.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const useIsPracticeModeEnabled = shortId => {
  const [showPracticeModeOverlay, setShowPracticeModeOverlay] = useState(isEnabledForShort(shortId));
  const {
    isNotLaptop
  } = useMediaQuery();
  return {
    isPracticeModeEnabled: isNotLaptop && showPracticeModeOverlay,
    setShowPracticeModeOverlay
  };
};